<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="dialog-container">
    <div class="scrollable-table">
        <div class="default-windows">
            <h2>Default Windows <span>(max 10)</span></h2>
            <p class="selected-win-info-text">Selected windows will be populated on launch of LMS</p>

            <div class="windows-row" *ngFor='let userPrefWindow of userPrefWindowArr; let i = index'>
                <lms-user-profile-window [tabLevel]='tabLevel +  (i*5)' [userPrefWindow]='userPrefWindow' [index]='i'></lms-user-profile-window>
            </div>
            <div *ngIf='(userPrefWindowArr && userPrefWindowArr.length == 5)'>
                <a href="javascript:void(0)" (keydown.space)='addMoreWindow();' (keydown.spacebar)='addMoreWindow();' (click)='addMoreWindow();' class="clear-link" tabindex="{{tabLevel+51}}"> + Add More</a>
            </div>
        </div>

        <div class="alert-settings">
            <h2>Alert Settings</h2>
            <div class="alert-column">
                <div class="alert-radiobox">
                    <p-radioButton labelStyleClass="radio-btn-lable" [tabindex]='tabLevel+52' name="alertValue" value="SYS" label="System wide Level 1 Alerts" [(ngModel)]="alertValue"></p-radioButton>
                </div>
                <div class="alert-description">
                    <p class="light-grey-text">(Director Alerts)<br><br> Receive Out of Service alerts for the whole network
                    </p>
                </div>
            </div>
            <div class="alert-column">
                <div class="alert-radiobox">
                    <p-radioButton labelStyleClass="radio-btn-lable" [tabindex]='tabLevel+53' name="alertValue" value="DES" label="Desk Alerts" (click)="updateAlertType()" [(ngModel)]="alertValue"></p-radioButton>
                </div>
                <div class="alert-description">
                    <p class="light-grey-text">Receive both Out of Service and Other alerts for Selected Desk
                    </p>
                    <br>
                    <p>Select Desk</p>
                    <p class="light-grey-text">
                        <p-dropdown [options]="deskList" [tabindex]='tabLevel+54' [disabled]="alertValue !== 'DES'" [(ngModel)]='selectedDeskName'>
                            <ng-template let-deskName pTemplate="deskName">
                                <div class="p-helper-clearfix">
                                    <div> {{deskName.label}} </div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </p>
                </div>
            </div>
            <div class="alert-column">
                <div class="alert-radiobox">
                    <p-radioButton labelStyleClass="radio-btn-lable" name="alertValue" [tabindex]='tabLevel+55' value="NON" label="None" (click)="updateAlertType()" [(ngModel)]="alertValue"></p-radioButton>
                </div>
                <div class="alert-description">
                    <p class="light-grey-text">System will not show any alerts
                    </p>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
    <div class="dialog-buttons">
        <span class="user-profile-helpUrl p-button-secondary" (click)='showHelpUrl();'>
          <i class="help-icon"></i>  Help
        </span>
        <span class="pull-left italic-text user-setting-apply-note">
				* Changes saved will appear in next user session
			</span>
        <span class="pull-right">
				<button class="p-button-secondary" tabindex="{{tabLevel+56}}" (click)='closeUserProfilePopup()'>Cancel</button>
					<button class="p-button-primary" tabindex="{{tabLevel+57}}" (click)='submitData()' id="userProfileDefaultBtn"
          [ngClass]="{'p-button-disabled': !alertValue}" [disabled]="!alertValue">
            Apply *</button>
			</span>

    </div>
</div>